/**
 * Penanggalan Bali (Pawukon) - siklus 210 hari.
 * Kami sediakan: Saptawara (sama dengan hari Masehi, nama Bali),
 * Pancawara (siklus 5), Triwara (siklus 3), dan Wuku (30 wuku).
 * Epoch konsisten dengan kalender Jawa (8 Juli 1633 M = awal Sinta).
 */

import { julianDay } from "./dates";

export const SAPTAWARA_BALI = [
  "Redite", "Soma", "Anggara", "Buda", "Wraspati", "Sukra", "Saniscara",
]; // Sun..Sat

export const PANCAWARA_BALI = [
  "Umanis", "Paing", "Pon", "Wage", "Kliwon",
]; // = Legi/Pahing/Pon/Wage/Kliwon dengan nama Bali

export const TRIWARA = ["Pasah", "Beteng", "Kajeng"];

export const WUKU_BALI = [
  "Sinta", "Landep", "Ukir", "Kulantir", "Tolu", "Gumbreg",
  "Wariga", "Warigadean", "Julungwangi", "Sungsang", "Dungulan", "Kuningan",
  "Langkir", "Medangsia", "Pujut", "Pahang", "Krulut", "Merakih",
  "Tambir", "Medangkungan", "Matal", "Uye", "Menail", "Prangbakat",
  "Bala", "Ugu", "Wayang", "Kelawu", "Dukut", "Watugunung",
];

const EPOCH_JD = 2317768;

export interface BaliDate {
  saptawara: string;
  pancawara: string;
  triwara: string;
  wuku: string;
  /** Hari ke-N dalam wuku (1-7) */
  hariWuku: number;
}

export function gregorianToBali(year: number, month: number, day: number): BaliDate {
  const jd = julianDay(year, month, day);
  const diff = jd - EPOCH_JD;

  const dow = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  const saptawara = SAPTAWARA_BALI[dow];
  const pancawara = PANCAWARA_BALI[((diff % 5) + 5) % 5];
  const triwara = TRIWARA[((diff % 3) + 3) % 3];
  const wukuDay = ((diff % 210) + 210) % 210;
  const wuku = WUKU_BALI[Math.floor(wukuDay / 7)];
  const hariWuku = (wukuDay % 7) + 1;

  return { saptawara, pancawara, triwara, wuku, hariWuku };
}